import { render } from "./UpdateTemplate.vue?vue&type=template&id=45ebf62b&scoped=true"
import script from "./UpdateTemplate.vue?vue&type=script&lang=js"
export * from "./UpdateTemplate.vue?vue&type=script&lang=js"

import "./UpdateTemplate.vue?vue&type=style&index=0&id=45ebf62b&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ebf62b"]])

export default __exports__